// source: pbtypes/tools/cloud_api/device_health_issue.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.cloud_api.AccessPointFaultDetails', null, global);
goog.exportSymbol('proto.cloud_api.CloudCustomIssue', null, global);
goog.exportSymbol('proto.cloud_api.CloudCustomIssue.CloudCustomIssueEnum', null, global);
goog.exportSymbol('proto.cloud_api.CloudFieldDetails', null, global);
goog.exportSymbol('proto.cloud_api.CloudRepeatedField', null, global);
goog.exportSymbol('proto.cloud_api.ComparisonField', null, global);
goog.exportSymbol('proto.cloud_api.ComparisonField.ComparisonOperator', null, global);
goog.exportSymbol('proto.cloud_api.ComparisonField.ConditionCase', null, global);
goog.exportSymbol('proto.cloud_api.ComparisonField.FieldValueCase', null, global);
goog.exportSymbol('proto.cloud_api.DeviceHealthIssue', null, global);
goog.exportSymbol('proto.cloud_api.DockFaultDetails', null, global);
goog.exportSymbol('proto.cloud_api.HealthIssue', null, global);
goog.exportSymbol('proto.cloud_api.HealthIssue.IssueSourceEnum', null, global);
goog.exportSymbol('proto.cloud_api.HealthIssueIdentifier', null, global);
goog.exportSymbol('proto.cloud_api.HealthIssueIdentifier.Enum', null, global);
goog.exportSymbol('proto.cloud_api.HealthStatus', null, global);
goog.exportSymbol('proto.cloud_api.HealthStatus.HealthStatusEnum', null, global);
goog.exportSymbol('proto.cloud_api.IssueDetails', null, global);
goog.exportSymbol('proto.cloud_api.IssueDetails.IssueDetailsCase', null, global);
goog.exportSymbol('proto.cloud_api.Module', null, global);
goog.exportSymbol('proto.cloud_api.Module.ModuleEnum', null, global);
goog.exportSymbol('proto.cloud_api.VehicleFaultDetails', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.HealthStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.HealthStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.HealthStatus.displayName = 'proto.cloud_api.HealthStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.Module = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.Module, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.Module.displayName = 'proto.cloud_api.Module';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.HealthIssue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.HealthIssue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.HealthIssue.displayName = 'proto.cloud_api.HealthIssue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.HealthIssueIdentifier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.HealthIssueIdentifier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.HealthIssueIdentifier.displayName = 'proto.cloud_api.HealthIssueIdentifier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.DeviceHealthIssue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.DeviceHealthIssue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.DeviceHealthIssue.displayName = 'proto.cloud_api.DeviceHealthIssue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.IssueDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.cloud_api.IssueDetails.oneofGroups_);
};
goog.inherits(proto.cloud_api.IssueDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.IssueDetails.displayName = 'proto.cloud_api.IssueDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.AccessPointFaultDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.AccessPointFaultDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.AccessPointFaultDetails.displayName = 'proto.cloud_api.AccessPointFaultDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.DockFaultDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.DockFaultDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.DockFaultDetails.displayName = 'proto.cloud_api.DockFaultDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.VehicleFaultDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.VehicleFaultDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.VehicleFaultDetails.displayName = 'proto.cloud_api.VehicleFaultDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.CloudFieldDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.CloudFieldDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.CloudFieldDetails.displayName = 'proto.cloud_api.CloudFieldDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.ComparisonField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.cloud_api.ComparisonField.oneofGroups_);
};
goog.inherits(proto.cloud_api.ComparisonField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.ComparisonField.displayName = 'proto.cloud_api.ComparisonField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.CloudRepeatedField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud_api.CloudRepeatedField.repeatedFields_, null);
};
goog.inherits(proto.cloud_api.CloudRepeatedField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.CloudRepeatedField.displayName = 'proto.cloud_api.CloudRepeatedField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud_api.CloudCustomIssue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud_api.CloudCustomIssue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud_api.CloudCustomIssue.displayName = 'proto.cloud_api.CloudCustomIssue';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.HealthStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.HealthStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.HealthStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.HealthStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.HealthStatus}
 */
proto.cloud_api.HealthStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.HealthStatus;
  return proto.cloud_api.HealthStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.HealthStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.HealthStatus}
 */
proto.cloud_api.HealthStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.HealthStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.HealthStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.HealthStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.HealthStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.cloud_api.HealthStatus.HealthStatusEnum = {
  UNKNOWN: 0,
  GREEN: 1,
  YELLOW: 2,
  RED: 3,
  OUT_OF_SERVICE: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.Module.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.Module.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.Module} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.Module.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.Module}
 */
proto.cloud_api.Module.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.Module;
  return proto.cloud_api.Module.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.Module} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.Module}
 */
proto.cloud_api.Module.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.Module.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.Module.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.Module} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.Module.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.cloud_api.Module.ModuleEnum = {
  UNKNOWN: 0,
  PROP: 1,
  BATTERY: 2,
  PARACHUTE: 3,
  SPOTLIGHT: 4,
  NIGHTSENSE: 5,
  SPEAKER_MIC: 6,
  SENSOR_PACKAGE: 7,
  VEHICLE_SD_CARD: 28,
  VEHICLE_SOFTWARE: 29,
  VEHICLE_HARDWARE: 30,
  VEHICLE_ATTACHMENT: 31,
  VEHICLE_MODEM: 33,
  VEHICLE_CELLULAR: 40,
  VEHICLE_CELLULAR_MODEM_ATTACHMENT: 41,
  VEHICLE_REMOTE_ID: 42,
  VEHICLE_CONNECTIVITY: 43,
  MAIN_LOGIC_BOARD: 8,
  INSPECTION_CAMERA: 9,
  REAR_CAMERA: 10,
  FRONT_CAMERA: 11,
  RAIN_SENSOR: 12,
  LATCH: 13,
  POWER_SUPPLY: 14,
  COMPUTE: 15,
  USER_BOX: 16,
  INTAKE_FAN: 17,
  PERIMETER_LED_HEATER: 18,
  TEC: 19,
  DOCK_CORE: 20,
  PLATFORM_PCBA: 21,
  ROOF: 22,
  PLATFORM: 23,
  PLATFORM_CHARGER: 24,
  ANEMOMETER: 25,
  DOCK_FILTER: 26,
  DOCK_SOFTWARE: 35,
  ADS_B: 27,
  RADIO: 32,
  ACCESS_POINT_SOFTWARE: 36,
  GNSS_SENSOR: 38,
  NETWORK: 34,
  PATHFINDER: 37,
  OPERATIONAL_STATUS_VEHICLE: 44,
  OPERATIONAL_STATUS_DOCK: 45,
  OPERATIONAL_STATUS_ACCESS_POINT: 46
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.HealthIssue.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.HealthIssue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.HealthIssue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.HealthIssue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.HealthIssue}
 */
proto.cloud_api.HealthIssue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.HealthIssue;
  return proto.cloud_api.HealthIssue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.HealthIssue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.HealthIssue}
 */
proto.cloud_api.HealthIssue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.HealthIssue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.HealthIssue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.HealthIssue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.HealthIssue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.cloud_api.HealthIssue.IssueSourceEnum = {
  UNKNOWN: 0,
  DOCK_FAULT: 1,
  VEHICLE_FAULT: 2,
  CLOUD_FIELD: 3,
  ACCESS_POINT_FAULT: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.HealthIssueIdentifier.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.HealthIssueIdentifier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.HealthIssueIdentifier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.HealthIssueIdentifier.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.HealthIssueIdentifier}
 */
proto.cloud_api.HealthIssueIdentifier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.HealthIssueIdentifier;
  return proto.cloud_api.HealthIssueIdentifier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.HealthIssueIdentifier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.HealthIssueIdentifier}
 */
proto.cloud_api.HealthIssueIdentifier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.HealthIssueIdentifier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.HealthIssueIdentifier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.HealthIssueIdentifier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.HealthIssueIdentifier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.cloud_api.HealthIssueIdentifier.Enum = {
  UNKNOWN: 0,
  UNSUPPORTED_BATTERY: 1,
  LOGGING_SPACE_LOW: 2,
  LOGGING_SD_CARD_MISSING: 3,
  LOGGING_SD_CARD_WRONG_FILESYSTEM: 4,
  LOGGING_SD_CARD_SLOW: 5,
  LOGGING_SD_CARD_NOT_ENCRYPTED: 6,
  LOGGING_SD_CARD_SECURITY_KEY_REQUIRED: 7,
  LOGGING_SD_CARD_SECURITY_ACTIVATION_IN_PROGRESS: 8,
  LOGGING_SD_CARD_SECURITY_ACTIVATION_FAILED: 9,
  MEDIA_SD_CARD_MISSING: 10,
  MEDIA_SD_CARD_WRONG_ENCRYPTION_KEY: 11,
  MEDIA_SD_CARD_UNFORMATTED: 12,
  MEDIA_SD_CARD_CORRUPTED: 13,
  MEDIA_SD_CARD_SLOW: 14,
  AIRHAWK_REQUIRES_RESTART: 15,
  ONBOARD_SOFTWARE_FAILURE: 16,
  SOC_FLASHPACK_MISMATCH: 17,
  SOC_CONFIG_MISMATCH: 18,
  SOC_SERIAL_NUMBER_MISMATCH: 19,
  FIRMWARE_MISCONFIGURED: 20,
  SETUP_FLIGHT_REQUIRED: 21,
  SIM_AUTOMATIC_ALTITUDE_FAILED: 22,
  VEHICLE_GROUNDED_BY_SKYDIO_CLOUD: 23,
  UNSUPPORTED_SIM: 24,
  UNSUPPORTED_SIM_ON_CELLULAR_ATTACHMENT: 25,
  PATHFINDER_UNAVAILABLE: 26,
  INCOMPATIBLE_PATHFINDER_MAP: 27,
  PARACHUTE_PARTIALLY_OPERATIONAL: 28,
  PARACHUTE_LOGGING_FAILURE: 29,
  MINOR_PARACHUTE_WEAR: 30,
  CRITICAL_PARACHUTE_FAILURE: 31,
  PARACHUTE_AUTO_DEPLOY_FAILURE: 32,
  PARACHUTE_DEPLOYED: 33,
  PARACHUTE_REQUIRED_BUT_NOT_DETECTED: 34,
  PARACHUTE_NOT_DETECTED: 35,
  PARACHUTE_VERSION_NOT_DETECTED: 36,
  REMOTE_ID_REGISTRATION_NOT_DETECTED: 37,
  INSPECTION_CAMERA_FAILURE: 38,
  REAR_CAMERA_FAILURE: 39,
  CAMERA_FAILURE: 40,
  FRONT_CAMERA_FAILURE: 41,
  INTAKE_FAN_TEMPERATURE_LOW: 42,
  ROOF_TEMPERATURE_LOW: 43,
  ETHERNET_CONNECTION_DEGRADED: 44,
  MISMATCHED_EXTERNAL_RADIO: 45,
  ROOF_OPEN_POSITION_OUT_OF_BOUNDS: 46,
  ROOF_ACTUATION_BLOCKED: 47,
  PORT_ROOF_MOTOR_OVERTEMPERATURE_WARNING: 48,
  PORT_ROOF_MOTOR_OVERTEMPERATURE_SHUTDOWN: 49,
  STARBOARD_ROOF_MOTOR_OVERTEMPERATURE_WARNING: 50,
  STARBOARD_ROOF_MOTOR_OVERTEMPERATURE_SHUTDOWN: 51,
  PORT_ROOF_MOTOR_NO_LOAD_DETECTED: 52,
  STARBOARD_ROOF_MOTOR_NO_LOAD_DETECTED: 53,
  PORT_ROOF_MOTOR_OVERCURRENT_SHUTDOWN: 54,
  STARBOARD_ROOF_MOTOR_OVERCURRENT_SHUTDOWN: 55,
  PLATFORM_EXTENDED_SENSOR_OUT_OF_BOUNDS: 56,
  PLATFORM_EXTENDED_SENSOR_CRITICAL_OUT_OF_BOUNDS: 57,
  PLATFORM_RETRACTED_SENSOR_OUT_OF_BOUNDS: 58,
  PLATFORM_RETRACTED_SENSOR_CRITICAL_OUT_OF_BOUNDS: 59,
  PLATFORM_MOTOR_OVERTEMPERATURE_SHUTDOWN: 60,
  PLATFORM_MOTOR_OVERCURRENT_SHUTDOWN: 61,
  E_STOP_ACTIVE: 62,
  CHARGER_HALL_SENSOR_OUT_OF_BOUNDS: 63,
  CHARGER_HALL_SENSOR_CRITICAL_OUT_OF_BOUNDS: 64,
  CHARGER_MOTOR_OVERTEMPERATURE_SHUTDOWN: 65,
  CHARGER_MOTOR_OVERCURRENT_SHUTDOWN: 66,
  CHARGER_MOTOR_NO_LOAD_DETECTED: 67,
  RADIO_COMMUNICATION_FAULT: 68,
  RADIO_POWER_FAILURE: 69,
  WIRELESS_STATS_UNRELIABLE: 70,
  LOW_STORAGE_SPACE: 71,
  ADS_B_MESSAGES_ARE_NOT_RELIABLE: 72,
  GNSS_SIGNALS_NOT_RELIABLE: 73,
  GNSS_LOCATION_IS_NOT_HIGH_QUALITY: 74,
  PROPS_NEED_TO_BE_REALIGNED: 75,
  ACCELERATED_PROPELLER_WEAR: 76,
  BATTERY_CONNECTOR_WEAR: 77,
  PROPELLERS_NEED_TO_BE_REPLACED: 78,
  UNCERTIFIED_SIM: 79,
  LINKED_EXTERNAL_RADIO_OFFLINE: 80,
  BATTERY_REPLACEMENT_RECOMMENDED: 81,
  BATTERY_FIRMWARE_OUTDATED: 82,
  PARACHUTE_EXPIRED: 83,
  UNKNOWN_FLIGHT_SYSTEM_SOFTWARE: 84,
  UNSUPPORTED_FLIGHT_SYSTEM_SOFTWARE: 85,
  SOFTWARE_VERSION_MISMATCH: 86,
  PATHFINDER_MAP_DATA_NOT_GENERATED: 87,
  UPDATING_PATHFINDER_MAP_DATA: 88,
  AGL_GEOFENCES_UNAVAILABLE: 89,
  DEVICE_OUT_OF_SERVICE: 90,
  RAIN_DETECTED_WITH_DROPPER: 91,
  TRAINING_SCENARIO_LOAD_FAILED: 92
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.DeviceHealthIssue.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.DeviceHealthIssue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.DeviceHealthIssue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.DeviceHealthIssue.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
description: jspb.Message.getFieldWithDefault(msg, 2, ""),
resolutionRecommendation: jspb.Message.getFieldWithDefault(msg, 3, ""),
impliedHealthStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
issueSource: jspb.Message.getFieldWithDefault(msg, 5, 0),
issueDetails: (f = msg.getIssueDetails()) && proto.cloud_api.IssueDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.DeviceHealthIssue}
 */
proto.cloud_api.DeviceHealthIssue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.DeviceHealthIssue;
  return proto.cloud_api.DeviceHealthIssue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.DeviceHealthIssue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.DeviceHealthIssue}
 */
proto.cloud_api.DeviceHealthIssue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setResolutionRecommendation(value);
      break;
    case 4:
      var value = /** @type {!proto.cloud_api.HealthStatus.HealthStatusEnum} */ (reader.readEnum());
      msg.setImpliedHealthStatus(value);
      break;
    case 5:
      var value = /** @type {!proto.cloud_api.HealthIssue.IssueSourceEnum} */ (reader.readEnum());
      msg.setIssueSource(value);
      break;
    case 6:
      var value = new proto.cloud_api.IssueDetails;
      reader.readMessage(value,proto.cloud_api.IssueDetails.deserializeBinaryFromReader);
      msg.setIssueDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.DeviceHealthIssue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.DeviceHealthIssue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.DeviceHealthIssue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.DeviceHealthIssue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResolutionRecommendation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getImpliedHealthStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getIssueSource();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIssueDetails();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.cloud_api.IssueDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.cloud_api.DeviceHealthIssue.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_api.DeviceHealthIssue} returns this
 */
proto.cloud_api.DeviceHealthIssue.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.cloud_api.DeviceHealthIssue.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_api.DeviceHealthIssue} returns this
 */
proto.cloud_api.DeviceHealthIssue.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string resolution_recommendation = 3;
 * @return {string}
 */
proto.cloud_api.DeviceHealthIssue.prototype.getResolutionRecommendation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud_api.DeviceHealthIssue} returns this
 */
proto.cloud_api.DeviceHealthIssue.prototype.setResolutionRecommendation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional HealthStatus.HealthStatusEnum implied_health_status = 4;
 * @return {!proto.cloud_api.HealthStatus.HealthStatusEnum}
 */
proto.cloud_api.DeviceHealthIssue.prototype.getImpliedHealthStatus = function() {
  return /** @type {!proto.cloud_api.HealthStatus.HealthStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.cloud_api.HealthStatus.HealthStatusEnum} value
 * @return {!proto.cloud_api.DeviceHealthIssue} returns this
 */
proto.cloud_api.DeviceHealthIssue.prototype.setImpliedHealthStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional HealthIssue.IssueSourceEnum issue_source = 5;
 * @return {!proto.cloud_api.HealthIssue.IssueSourceEnum}
 */
proto.cloud_api.DeviceHealthIssue.prototype.getIssueSource = function() {
  return /** @type {!proto.cloud_api.HealthIssue.IssueSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.cloud_api.HealthIssue.IssueSourceEnum} value
 * @return {!proto.cloud_api.DeviceHealthIssue} returns this
 */
proto.cloud_api.DeviceHealthIssue.prototype.setIssueSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional IssueDetails issue_details = 6;
 * @return {?proto.cloud_api.IssueDetails}
 */
proto.cloud_api.DeviceHealthIssue.prototype.getIssueDetails = function() {
  return /** @type{?proto.cloud_api.IssueDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud_api.IssueDetails, 6));
};


/**
 * @param {?proto.cloud_api.IssueDetails|undefined} value
 * @return {!proto.cloud_api.DeviceHealthIssue} returns this
*/
proto.cloud_api.DeviceHealthIssue.prototype.setIssueDetails = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.DeviceHealthIssue} returns this
 */
proto.cloud_api.DeviceHealthIssue.prototype.clearIssueDetails = function() {
  return this.setIssueDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.DeviceHealthIssue.prototype.hasIssueDetails = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.cloud_api.IssueDetails.oneofGroups_ = [[3,4,5,6]];

/**
 * @enum {number}
 */
proto.cloud_api.IssueDetails.IssueDetailsCase = {
  ISSUE_DETAILS_NOT_SET: 0,
  DOCK_FAULT_DETAILS: 3,
  VEHICLE_FAULT_DETAILS: 4,
  CLOUD_FIELD_DETAILS: 5,
  ACCESS_POINT_FAULT_DETAILS: 6
};

/**
 * @return {proto.cloud_api.IssueDetails.IssueDetailsCase}
 */
proto.cloud_api.IssueDetails.prototype.getIssueDetailsCase = function() {
  return /** @type {proto.cloud_api.IssueDetails.IssueDetailsCase} */(jspb.Message.computeOneofCase(this, proto.cloud_api.IssueDetails.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.IssueDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.IssueDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.IssueDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.IssueDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
module: jspb.Message.getFieldWithDefault(msg, 1, 0),
moduleImpact: jspb.Message.getFieldWithDefault(msg, 2, 0),
dockFaultDetails: (f = msg.getDockFaultDetails()) && proto.cloud_api.DockFaultDetails.toObject(includeInstance, f),
vehicleFaultDetails: (f = msg.getVehicleFaultDetails()) && proto.cloud_api.VehicleFaultDetails.toObject(includeInstance, f),
cloudFieldDetails: (f = msg.getCloudFieldDetails()) && proto.cloud_api.CloudFieldDetails.toObject(includeInstance, f),
accessPointFaultDetails: (f = msg.getAccessPointFaultDetails()) && proto.cloud_api.AccessPointFaultDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.IssueDetails}
 */
proto.cloud_api.IssueDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.IssueDetails;
  return proto.cloud_api.IssueDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.IssueDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.IssueDetails}
 */
proto.cloud_api.IssueDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.cloud_api.Module.ModuleEnum} */ (reader.readEnum());
      msg.setModule(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud_api.HealthStatus.HealthStatusEnum} */ (reader.readEnum());
      msg.setModuleImpact(value);
      break;
    case 3:
      var value = new proto.cloud_api.DockFaultDetails;
      reader.readMessage(value,proto.cloud_api.DockFaultDetails.deserializeBinaryFromReader);
      msg.setDockFaultDetails(value);
      break;
    case 4:
      var value = new proto.cloud_api.VehicleFaultDetails;
      reader.readMessage(value,proto.cloud_api.VehicleFaultDetails.deserializeBinaryFromReader);
      msg.setVehicleFaultDetails(value);
      break;
    case 5:
      var value = new proto.cloud_api.CloudFieldDetails;
      reader.readMessage(value,proto.cloud_api.CloudFieldDetails.deserializeBinaryFromReader);
      msg.setCloudFieldDetails(value);
      break;
    case 6:
      var value = new proto.cloud_api.AccessPointFaultDetails;
      reader.readMessage(value,proto.cloud_api.AccessPointFaultDetails.deserializeBinaryFromReader);
      msg.setAccessPointFaultDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.IssueDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.IssueDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.IssueDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.IssueDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getModule();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getModuleImpact();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDockFaultDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.cloud_api.DockFaultDetails.serializeBinaryToWriter
    );
  }
  f = message.getVehicleFaultDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.cloud_api.VehicleFaultDetails.serializeBinaryToWriter
    );
  }
  f = message.getCloudFieldDetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.cloud_api.CloudFieldDetails.serializeBinaryToWriter
    );
  }
  f = message.getAccessPointFaultDetails();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.cloud_api.AccessPointFaultDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional Module.ModuleEnum module = 1;
 * @return {!proto.cloud_api.Module.ModuleEnum}
 */
proto.cloud_api.IssueDetails.prototype.getModule = function() {
  return /** @type {!proto.cloud_api.Module.ModuleEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.cloud_api.Module.ModuleEnum} value
 * @return {!proto.cloud_api.IssueDetails} returns this
 */
proto.cloud_api.IssueDetails.prototype.setModule = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional HealthStatus.HealthStatusEnum module_impact = 2;
 * @return {!proto.cloud_api.HealthStatus.HealthStatusEnum}
 */
proto.cloud_api.IssueDetails.prototype.getModuleImpact = function() {
  return /** @type {!proto.cloud_api.HealthStatus.HealthStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud_api.HealthStatus.HealthStatusEnum} value
 * @return {!proto.cloud_api.IssueDetails} returns this
 */
proto.cloud_api.IssueDetails.prototype.setModuleImpact = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional DockFaultDetails dock_fault_details = 3;
 * @return {?proto.cloud_api.DockFaultDetails}
 */
proto.cloud_api.IssueDetails.prototype.getDockFaultDetails = function() {
  return /** @type{?proto.cloud_api.DockFaultDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud_api.DockFaultDetails, 3));
};


/**
 * @param {?proto.cloud_api.DockFaultDetails|undefined} value
 * @return {!proto.cloud_api.IssueDetails} returns this
*/
proto.cloud_api.IssueDetails.prototype.setDockFaultDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.cloud_api.IssueDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.IssueDetails} returns this
 */
proto.cloud_api.IssueDetails.prototype.clearDockFaultDetails = function() {
  return this.setDockFaultDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.IssueDetails.prototype.hasDockFaultDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional VehicleFaultDetails vehicle_fault_details = 4;
 * @return {?proto.cloud_api.VehicleFaultDetails}
 */
proto.cloud_api.IssueDetails.prototype.getVehicleFaultDetails = function() {
  return /** @type{?proto.cloud_api.VehicleFaultDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud_api.VehicleFaultDetails, 4));
};


/**
 * @param {?proto.cloud_api.VehicleFaultDetails|undefined} value
 * @return {!proto.cloud_api.IssueDetails} returns this
*/
proto.cloud_api.IssueDetails.prototype.setVehicleFaultDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.cloud_api.IssueDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.IssueDetails} returns this
 */
proto.cloud_api.IssueDetails.prototype.clearVehicleFaultDetails = function() {
  return this.setVehicleFaultDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.IssueDetails.prototype.hasVehicleFaultDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CloudFieldDetails cloud_field_details = 5;
 * @return {?proto.cloud_api.CloudFieldDetails}
 */
proto.cloud_api.IssueDetails.prototype.getCloudFieldDetails = function() {
  return /** @type{?proto.cloud_api.CloudFieldDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud_api.CloudFieldDetails, 5));
};


/**
 * @param {?proto.cloud_api.CloudFieldDetails|undefined} value
 * @return {!proto.cloud_api.IssueDetails} returns this
*/
proto.cloud_api.IssueDetails.prototype.setCloudFieldDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.cloud_api.IssueDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.IssueDetails} returns this
 */
proto.cloud_api.IssueDetails.prototype.clearCloudFieldDetails = function() {
  return this.setCloudFieldDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.IssueDetails.prototype.hasCloudFieldDetails = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional AccessPointFaultDetails access_point_fault_details = 6;
 * @return {?proto.cloud_api.AccessPointFaultDetails}
 */
proto.cloud_api.IssueDetails.prototype.getAccessPointFaultDetails = function() {
  return /** @type{?proto.cloud_api.AccessPointFaultDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud_api.AccessPointFaultDetails, 6));
};


/**
 * @param {?proto.cloud_api.AccessPointFaultDetails|undefined} value
 * @return {!proto.cloud_api.IssueDetails} returns this
*/
proto.cloud_api.IssueDetails.prototype.setAccessPointFaultDetails = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.cloud_api.IssueDetails.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.IssueDetails} returns this
 */
proto.cloud_api.IssueDetails.prototype.clearAccessPointFaultDetails = function() {
  return this.setAccessPointFaultDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.IssueDetails.prototype.hasAccessPointFaultDetails = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.AccessPointFaultDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.AccessPointFaultDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.AccessPointFaultDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.AccessPointFaultDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
accessPointFaultId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.AccessPointFaultDetails}
 */
proto.cloud_api.AccessPointFaultDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.AccessPointFaultDetails;
  return proto.cloud_api.AccessPointFaultDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.AccessPointFaultDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.AccessPointFaultDetails}
 */
proto.cloud_api.AccessPointFaultDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccessPointFaultId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.AccessPointFaultDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.AccessPointFaultDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.AccessPointFaultDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.AccessPointFaultDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessPointFaultId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 access_point_fault_id = 1;
 * @return {number}
 */
proto.cloud_api.AccessPointFaultDetails.prototype.getAccessPointFaultId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud_api.AccessPointFaultDetails} returns this
 */
proto.cloud_api.AccessPointFaultDetails.prototype.setAccessPointFaultId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.DockFaultDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.DockFaultDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.DockFaultDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.DockFaultDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
dockFaultId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.DockFaultDetails}
 */
proto.cloud_api.DockFaultDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.DockFaultDetails;
  return proto.cloud_api.DockFaultDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.DockFaultDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.DockFaultDetails}
 */
proto.cloud_api.DockFaultDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDockFaultId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.DockFaultDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.DockFaultDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.DockFaultDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.DockFaultDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDockFaultId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 dock_fault_id = 1;
 * @return {number}
 */
proto.cloud_api.DockFaultDetails.prototype.getDockFaultId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud_api.DockFaultDetails} returns this
 */
proto.cloud_api.DockFaultDetails.prototype.setDockFaultId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.VehicleFaultDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.VehicleFaultDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.VehicleFaultDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.VehicleFaultDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleFaultId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.VehicleFaultDetails}
 */
proto.cloud_api.VehicleFaultDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.VehicleFaultDetails;
  return proto.cloud_api.VehicleFaultDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.VehicleFaultDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.VehicleFaultDetails}
 */
proto.cloud_api.VehicleFaultDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicleFaultId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.VehicleFaultDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.VehicleFaultDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.VehicleFaultDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.VehicleFaultDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleFaultId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 vehicle_fault_id = 1;
 * @return {number}
 */
proto.cloud_api.VehicleFaultDetails.prototype.getVehicleFaultId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud_api.VehicleFaultDetails} returns this
 */
proto.cloud_api.VehicleFaultDetails.prototype.setVehicleFaultId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.CloudFieldDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.CloudFieldDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.CloudFieldDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.CloudFieldDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
comparisonFieldDetails: (f = msg.getComparisonFieldDetails()) && proto.cloud_api.ComparisonField.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.CloudFieldDetails}
 */
proto.cloud_api.CloudFieldDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.CloudFieldDetails;
  return proto.cloud_api.CloudFieldDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.CloudFieldDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.CloudFieldDetails}
 */
proto.cloud_api.CloudFieldDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud_api.ComparisonField;
      reader.readMessage(value,proto.cloud_api.ComparisonField.deserializeBinaryFromReader);
      msg.setComparisonFieldDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.CloudFieldDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.CloudFieldDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.CloudFieldDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.CloudFieldDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComparisonFieldDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud_api.ComparisonField.serializeBinaryToWriter
    );
  }
};


/**
 * optional ComparisonField comparison_field_details = 1;
 * @return {?proto.cloud_api.ComparisonField}
 */
proto.cloud_api.CloudFieldDetails.prototype.getComparisonFieldDetails = function() {
  return /** @type{?proto.cloud_api.ComparisonField} */ (
    jspb.Message.getWrapperField(this, proto.cloud_api.ComparisonField, 1));
};


/**
 * @param {?proto.cloud_api.ComparisonField|undefined} value
 * @return {!proto.cloud_api.CloudFieldDetails} returns this
*/
proto.cloud_api.CloudFieldDetails.prototype.setComparisonFieldDetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.CloudFieldDetails} returns this
 */
proto.cloud_api.CloudFieldDetails.prototype.clearComparisonFieldDetails = function() {
  return this.setComparisonFieldDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.CloudFieldDetails.prototype.hasComparisonFieldDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.cloud_api.ComparisonField.oneofGroups_ = [[1,2,3,8],[4,5,6,9]];

/**
 * @enum {number}
 */
proto.cloud_api.ComparisonField.FieldValueCase = {
  FIELD_VALUE_NOT_SET: 0,
  INT_VALUE: 1,
  FLOAT_VALUE: 2,
  BOOL_VALUE: 3,
  REPEATED_FIELD_VALUE: 8
};

/**
 * @return {proto.cloud_api.ComparisonField.FieldValueCase}
 */
proto.cloud_api.ComparisonField.prototype.getFieldValueCase = function() {
  return /** @type {proto.cloud_api.ComparisonField.FieldValueCase} */(jspb.Message.computeOneofCase(this, proto.cloud_api.ComparisonField.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.cloud_api.ComparisonField.ConditionCase = {
  CONDITION_NOT_SET: 0,
  INT_CONDITION: 4,
  FLOAT_CONDITION: 5,
  BOOL_CONDITION: 6,
  REPEATED_CONDITION: 9
};

/**
 * @return {proto.cloud_api.ComparisonField.ConditionCase}
 */
proto.cloud_api.ComparisonField.prototype.getConditionCase = function() {
  return /** @type {proto.cloud_api.ComparisonField.ConditionCase} */(jspb.Message.computeOneofCase(this, proto.cloud_api.ComparisonField.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.ComparisonField.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.ComparisonField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.ComparisonField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.ComparisonField.toObject = function(includeInstance, msg) {
  var f, obj = {
intValue: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
floatValue: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
boolValue: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
repeatedFieldValue: (f = msg.getRepeatedFieldValue()) && proto.cloud_api.CloudRepeatedField.toObject(includeInstance, f),
intCondition: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
floatCondition: (f = jspb.Message.getOptionalFloatingPointField(msg, 5)) == null ? undefined : f,
boolCondition: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
repeatedCondition: (f = msg.getRepeatedCondition()) && proto.cloud_api.CloudRepeatedField.toObject(includeInstance, f),
operator: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.ComparisonField}
 */
proto.cloud_api.ComparisonField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.ComparisonField;
  return proto.cloud_api.ComparisonField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.ComparisonField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.ComparisonField}
 */
proto.cloud_api.ComparisonField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFloatValue(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoolValue(value);
      break;
    case 8:
      var value = new proto.cloud_api.CloudRepeatedField;
      reader.readMessage(value,proto.cloud_api.CloudRepeatedField.deserializeBinaryFromReader);
      msg.setRepeatedFieldValue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntCondition(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFloatCondition(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoolCondition(value);
      break;
    case 9:
      var value = new proto.cloud_api.CloudRepeatedField;
      reader.readMessage(value,proto.cloud_api.CloudRepeatedField.deserializeBinaryFromReader);
      msg.setRepeatedCondition(value);
      break;
    case 7:
      var value = /** @type {!proto.cloud_api.ComparisonField.ComparisonOperator} */ (reader.readEnum());
      msg.setOperator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.ComparisonField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.ComparisonField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.ComparisonField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.ComparisonField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getRepeatedFieldValue();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.cloud_api.CloudRepeatedField.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getRepeatedCondition();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.cloud_api.CloudRepeatedField.serializeBinaryToWriter
    );
  }
  f = message.getOperator();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.cloud_api.ComparisonField.ComparisonOperator = {
  UNKNOWN: 0,
  GREATER_THAN: 1,
  LESS_THAN: 2,
  EQUAL_TO: 3,
  GREATER_OR_EQUAL: 4,
  LESS_OR_EQUAL: 5,
  NOT_EQUAL: 6,
  SUBSET: 10,
  NOT_SUBSET: 11
};

/**
 * optional int32 int_value = 1;
 * @return {number}
 */
proto.cloud_api.ComparisonField.prototype.getIntValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.setIntValue = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.cloud_api.ComparisonField.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.clearIntValue = function() {
  return jspb.Message.setOneofField(this, 1, proto.cloud_api.ComparisonField.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.hasIntValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float float_value = 2;
 * @return {number}
 */
proto.cloud_api.ComparisonField.prototype.getFloatValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.setFloatValue = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.cloud_api.ComparisonField.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.clearFloatValue = function() {
  return jspb.Message.setOneofField(this, 2, proto.cloud_api.ComparisonField.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.hasFloatValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool bool_value = 3;
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.getBoolValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.setBoolValue = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.cloud_api.ComparisonField.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.clearBoolValue = function() {
  return jspb.Message.setOneofField(this, 3, proto.cloud_api.ComparisonField.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.hasBoolValue = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CloudRepeatedField repeated_field_value = 8;
 * @return {?proto.cloud_api.CloudRepeatedField}
 */
proto.cloud_api.ComparisonField.prototype.getRepeatedFieldValue = function() {
  return /** @type{?proto.cloud_api.CloudRepeatedField} */ (
    jspb.Message.getWrapperField(this, proto.cloud_api.CloudRepeatedField, 8));
};


/**
 * @param {?proto.cloud_api.CloudRepeatedField|undefined} value
 * @return {!proto.cloud_api.ComparisonField} returns this
*/
proto.cloud_api.ComparisonField.prototype.setRepeatedFieldValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.cloud_api.ComparisonField.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.clearRepeatedFieldValue = function() {
  return this.setRepeatedFieldValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.hasRepeatedFieldValue = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 int_condition = 4;
 * @return {number}
 */
proto.cloud_api.ComparisonField.prototype.getIntCondition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.setIntCondition = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.cloud_api.ComparisonField.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.clearIntCondition = function() {
  return jspb.Message.setOneofField(this, 4, proto.cloud_api.ComparisonField.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.hasIntCondition = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float float_condition = 5;
 * @return {number}
 */
proto.cloud_api.ComparisonField.prototype.getFloatCondition = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.setFloatCondition = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.cloud_api.ComparisonField.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.clearFloatCondition = function() {
  return jspb.Message.setOneofField(this, 5, proto.cloud_api.ComparisonField.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.hasFloatCondition = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool bool_condition = 6;
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.getBoolCondition = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.setBoolCondition = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.cloud_api.ComparisonField.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.clearBoolCondition = function() {
  return jspb.Message.setOneofField(this, 6, proto.cloud_api.ComparisonField.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.hasBoolCondition = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CloudRepeatedField repeated_condition = 9;
 * @return {?proto.cloud_api.CloudRepeatedField}
 */
proto.cloud_api.ComparisonField.prototype.getRepeatedCondition = function() {
  return /** @type{?proto.cloud_api.CloudRepeatedField} */ (
    jspb.Message.getWrapperField(this, proto.cloud_api.CloudRepeatedField, 9));
};


/**
 * @param {?proto.cloud_api.CloudRepeatedField|undefined} value
 * @return {!proto.cloud_api.ComparisonField} returns this
*/
proto.cloud_api.ComparisonField.prototype.setRepeatedCondition = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.cloud_api.ComparisonField.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.clearRepeatedCondition = function() {
  return this.setRepeatedCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud_api.ComparisonField.prototype.hasRepeatedCondition = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ComparisonOperator operator = 7;
 * @return {!proto.cloud_api.ComparisonField.ComparisonOperator}
 */
proto.cloud_api.ComparisonField.prototype.getOperator = function() {
  return /** @type {!proto.cloud_api.ComparisonField.ComparisonOperator} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.cloud_api.ComparisonField.ComparisonOperator} value
 * @return {!proto.cloud_api.ComparisonField} returns this
 */
proto.cloud_api.ComparisonField.prototype.setOperator = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud_api.CloudRepeatedField.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.CloudRepeatedField.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.CloudRepeatedField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.CloudRepeatedField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.CloudRepeatedField.toObject = function(includeInstance, msg) {
  var f, obj = {
stringValuesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.CloudRepeatedField}
 */
proto.cloud_api.CloudRepeatedField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.CloudRepeatedField;
  return proto.cloud_api.CloudRepeatedField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.CloudRepeatedField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.CloudRepeatedField}
 */
proto.cloud_api.CloudRepeatedField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addStringValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.CloudRepeatedField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.CloudRepeatedField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.CloudRepeatedField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.CloudRepeatedField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStringValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string string_values = 1;
 * @return {!Array<string>}
 */
proto.cloud_api.CloudRepeatedField.prototype.getStringValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.cloud_api.CloudRepeatedField} returns this
 */
proto.cloud_api.CloudRepeatedField.prototype.setStringValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.cloud_api.CloudRepeatedField} returns this
 */
proto.cloud_api.CloudRepeatedField.prototype.addStringValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud_api.CloudRepeatedField} returns this
 */
proto.cloud_api.CloudRepeatedField.prototype.clearStringValuesList = function() {
  return this.setStringValuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud_api.CloudCustomIssue.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud_api.CloudCustomIssue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud_api.CloudCustomIssue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.CloudCustomIssue.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud_api.CloudCustomIssue}
 */
proto.cloud_api.CloudCustomIssue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud_api.CloudCustomIssue;
  return proto.cloud_api.CloudCustomIssue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud_api.CloudCustomIssue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud_api.CloudCustomIssue}
 */
proto.cloud_api.CloudCustomIssue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud_api.CloudCustomIssue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud_api.CloudCustomIssue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud_api.CloudCustomIssue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud_api.CloudCustomIssue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.cloud_api.CloudCustomIssue.CloudCustomIssueEnum = {
  UNKNOWN: 0,
  PROPS_ALIGNMENT: 1,
  ACCELERATED_PROPELLER_WEAR: 2,
  BATTERY_FRETTING_RISK: 3
};

goog.object.extend(exports, proto.cloud_api);
